export default __webpack_public_path__ + "scripts/resource/6ec77a19486ef8811dd1f7d65486acb0.svg";